import React from 'react'
import './Select.scss';
export interface Props {
  optionValue: any;
  optionLabel: any;
  selectOptionStyle?: React.CSSProperties;
}
const SelectOptions = ({optionValue, optionLabel, selectOptionStyle}:Props) => {
  return (
    <option value={optionValue} style={selectOptionStyle && selectOptionStyle}>{optionLabel}</option>
  )
}

export default SelectOptions